import axios from "axios";
import React, { useContext, useState } from "react";
import { Authregcontext } from "../../context/Authregistercontext";
const Register = () => {
  const [credentials, setcredentials] = useState({
    username: undefined,
    email: undefined,
    password: undefined,
  });

  const { username, email, password, dispatch } = useContext(Authregcontext);
  const handlechange = (e) => {
    setcredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handlecick = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post(
        "http://localhost:8000/auth/register",
        credentials
      );
      dispatch({ type: "REGISTER", payload: res.data });
    } catch (err) {}
  };
  console.log(username);
  return (
    <div className="login">
      <div className="lcont">
        <input
          type="text"
          placeholder="username"
          id="username"
          className="linput"
          onChange={handlechange}
        />
        <input
          type="text"
          placeholder="password "
          id="email"
          className="linput"
          onChange={handlechange}
        />
        <input
          type="text"
          placeholder="password "
          id="password"
          className="linput"
          onChange={handlechange}
        />
        <button className="lbutton" onClick={handlecick}>
          Login
        </button>
      </div>
    </div>
  );
};
export default Register;
